<template>
    <div id="Epg" class="epg-container-block">
        <div class="epg-main-container">
            <div class="epg-header-container" v-if="headerContainer">
                <div class="main-title">
                    <h1 class="cat-title font-24">{{ $t("Program Guide") }}</h1>
                </div>
                <div class="date-time">
                    <h1 class="cat-title font-24">{{ upDateTime.time }}</h1>
                    <span>{{ upDateTime.date }}</span>
                </div>
            </div>
            <div class="callender-conatiner">
                <CallenderContainer @actSelectDate="actSelectDate"></CallenderContainer>
            </div>
            <div class="data-container">
                <div class="epg-data-container">
                    <div class="header-block">
                        <div class="current-day-name">
                            <!-- Monday -->
                        </div>
                        <div class="timelap-grid">
                            <a
                            class="right-arrow"
                            v-show="showRightArrow"
                            @click="rightScroll"
                            >
                            <img src="@/assets/icons/rightarrow.svg" />
                            </a>

                            <a
                            class="left-arrow"
                            v-show="showLeftArrow"
                            @click="leftScroll"
                            >
                            <img src="@/assets/icons/rightarrow.svg" />
                            </a>
                            <div class="timelap-container" ref="timeline">
                                <div class="timelapse-track">
                                    <div v-for="(label, i) in timeLabels" :key="label.left"
                                        class="time-line"
                                        :class="`time-line_${i}`"
                                        :style="{
                                        position: 'absolute',
                                        left: label.left + 'px',
                                        bottom: label.bottom,
                                        }">
                                        <span class="time">{{ label.label }}</span>
                                        <!-- <span
                                        class="line"
                                        :style="{
                                        height: label.height,
                                        width: label.width + 'px',
                                        backgroundColor: '#d1d1d1' // line color
                                        }"></span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="epg-body">
                        <div class="channel-program-block"  v-if="channelsData && channelsData.length > 0">
                            <div class="channel-block" ref="channels">
                                <div class="channel-block-overlay">
                                    <div v-for="(channel, i) in channelsData"  :key="`${i}-channel`" class="channel-block-single d-flex hand">
                                        <div class="channel-box">
                                            <channelBox :channel="channel" @actSelectedProgram="actSelectedProgram" />
                                        </div>
                                    </div>
                                    <div key="loading-channel" class="channel-block-single d-flex" v-if="showPaginationLoader">
                                        <Intersect 
                                            @enter="onEnter"
                                            @leave="onLeave"
                                            :root-margin="'0px 0px -50px 0px'"
                                            :threshold="[0.5]"
                                        >
                                            <div class="loader">
                                                
                                            </div>
                                        </Intersect>
                                    </div>
                                </div>
                            </div>
                            <div class="program-block">
                                <div class="program-block-overlay"  ref="programs" @scroll="handleScroll">
                                    <div v-for="(channel, i) in channelsData"  :key="`${i}-program`" class="program-block-single d-flex">
                                        <div class="program-box">
                                            <div id="line" 
                                            v-if="isToday"
                                            style="
                                                width: 3px;
                                                height: 100%;
                                                background: red;
                                                position: absolute;
                                                top: 0;
                                                left: 100px;
                                                z-index: 2;"
                                                :style="{left: liveLineLeft + 'px'}"
                                            ></div>
                                            <programsBox :channel="channel" :programsData="programsData" :selectedDate="selectedDate" @actSelectedProgram="actSelectedProgram"/>
                                        </div>
                                    </div>
                                    <div key="loading-program" class="program-block-single" v-if="showPaginationLoader">
                                        <div class="program-box loading-box"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="channel-program-block-loading" v-else>
                            <div class="channel-block" ref="channels">
                                <div class="channel-block-overlay">
                                    <div key="loading-channel" class="channel-block-single d-flex" v-for="(channel, i) in 15"  :key="`${i}-channel`">
                                        <div class="loader">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="program-block">
                                <div class="program-block-overlay"  ref="programs" @scroll="handleScroll">
                                    <div key="loading-program" class="program-block-single" v-for="(channel, i) in 15"  :key="`${i}-program`">
                                        <div class="program-box loading-box"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading" class="main-loader-layer">
            <div class="inner-loader-layer">
                <DotFlashing />
            </div>
        </div>
        <Popup  v-if="isLiveContentAccessError" :islogoNotRequired="true" width="max-content" margin="15% auto" radiusType="full" :closePopupEvent="() => { closePopup() }">
            <div class="confirmation-box" slot="component" >
            <div  class="confirmation-body">
                <h5>{{ getUnsubscribedMessage(errorContentData || activeChannel) }}</h5>
                <div class="login-button">
                <button class="button-primary login" type="Button" @click.stop="closePopup()">
                    {{ $t("OK") }}
                </button>
                </div>
            </div>
            </div>
        </Popup>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { eventBus } from "@/eventBus";
import PlaybackUtilities from "@/mixins/playbackUtilities.js";
import { observerInterSection } from "@/modules/observerInterSection";
import Intersect from "vue-intersect";
import Redirection from '@/mixins/redirection.js';
import { store } from "@/store/store";
import moment from "moment-timezone";
import { showSnackBar } from "@/utilities";

export default {
    name: 'EpgContainer',
    props: {
        headerContainer: {
            type: [Boolean, String, Object, Number],
            default: null,
        },
        channelCard: {
            type: [Boolean, String, Object, Number],
            default: null,
        },
        channelno: {
            type: [Boolean, String, Object, Number],
            default: null,
        },
        idepgchannel: {
            type: [Boolean, String, Object, Number],
            default: null,
        }
    },
    components: {
        Intersect,
        WaveLoader: () => import(/* webpackChunkName: "waveLoader" */ "@/components/Loaders/WaveLoader.vue"),
        ProgramContainer: () => import(/* webpackChunkName: "programContainer" */ "@/components/Epg/EpgProgramContainer.vue"),
        CallenderContainer: () => import(/* webpackChunkName: "callenderContainer" */ "@/components/Epg/CallenderContainer.vue"),
        ChannelContainer: () => import(/* webpackChunkName: "channelContainer" */ "@/components/Epg/ChannelContainer.vue"),
        DotFlashing: () => import(/* webpackChunkName: "dotFlashing" */ "@/components/Loaders/DotFlashing.vue"),
        programsBox: () => import(/* webpackChunkName: "programsBox" */ "@/components/Epg/programsBox.vue"),
        channelBox: () => import(/* webpackChunkName: "channelBox" */ "@/components/Epg/channelBox.vue"),
        Popup: () => import(/* webpackChunkName: "Popup" */ "@/components/Slots/Popup.vue"),
    },
    data() {
        return {
            finalData: null,
            channelsData: null,
            programsData: null,
            upDateTime: {
                date: '00-00-0000',
                time: '0:00'
            },
            weekArray: [],
            selectedChannelIndex: 0,
            selectedDateIndex: 1,
            loaderHeight: "2.5rem",
            localDisplayLang: null,
            loading: false,
            placeholder_lands: require('@/assets/placeholder-lands.svg'),
            activeProgramData: null,
            activeChannelData: null,
            pageNum: 1,
            totalCount: 0,
            showPaginationLoader: false,
            headerContainerEnable: true,
            ChannelContainerEnable: true,
            timeLabels: [],
            liveLineLeft: 0,
            pixelPerMinute: 5,
            epgStartTime: new Date().setHours(0, 0, 0, 0),
            epgEndTime: new Date().setHours(23, 59, 59, 999),
            isToday: true,
            isLiveContentAccessError: false,
            activeChannel: null,
            activeSelectedDate: null,
            showLeftArrow: false,
            showRightArrow: true,
            errorContentData: null
        }
    },
    computed: {
        ...mapGetters(["subscriberid", "profileid", "selectedChannel", "selectedDate"]),
    },
    created() {
        this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
        const today = moment().tz(moment.tz.guess()); // guess local timezone
        const localDate = today.format("YYYY-MM-DD");
        this.activeSelectedDate = localDate;
    },
    mounted() {
        this.generateTimeLabels();
        observerInterSection();
        this.updateLiveLine();
        this.checkIsToday();
        this.headerContainerEnable = this.headerContainer;
        this.ChannelContainerEnable = this.channelCard;
        let date = (new Date()).toISOString().split('T')[0];
        this.pageNum = 1;
        this.loadScript("/static/xmlToJson.js")
            .then(async (data) => {
                if (data.loaded) {
                    await this.fetchEpgXmlData(this.activeSelectedDate, this.pageNum);
                    // Ensure the first channel is selected if available
                    if (this.channelsData?.length > 0) {
                        let selectedDate = (new Date()).toISOString().split('T')[0];
                        this.setSelectedDate(selectedDate);
                        setTimeout(()=>{
                                const programs = this.$refs.programs;
                                const timeline = this.$refs.timeline;
                                programs.scrollLeft = this.isToday ? (this.liveLineLeft - (timeline.clientWidth / 2)) : 0;
                        }, 250);
                        // this.actionToPickActiveProgramsOFSelectedChannelANDSelectedDate(this.channelsData[0], 0, selectedDate);
                    }
                    this.doDate();
                    setInterval(() => {
                        this.doDate();
                    }, 1000 * 60);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        setInterval(() => {this.updateLiveLine();}, 30000);
        const programs = this.$refs.programs;
        if (programs) {
            programs.addEventListener('scroll', this.updateArrowVisibility);
            this.updateArrowVisibility();
        }
    },
    mixins: [PlaybackUtilities, Redirection],
    methods: {
        ...mapMutations(["setSelectedChannel", "setSelectedDate"]),
        ...mapActions(['mapEpgXmlData', 'getContent']),
        async fetchEpgXmlData(date, page) {
            let getTimeInUTC = this.getStartAndEndTimesInUTC(date)
            // const today = moment(); // Assuming today is January 1, 2025
            // const startDate = today.subtract(3, 'days').startOf('day').utc().format("YYYY-MM-DD HH:mm:ss");
            // const endDate = today.add(6 + 3, 'days').endOf('day').utc().format("YYYY-MM-DD HH:mm:ss"); // Add 6 days after resetting to today
            const payload = {
                start: getTimeInUTC.startUTC,
                stop: getTimeInUTC.endUTC,
                localDisplayLang: this.localDisplayLang,
                page,
                pagesize: 10,
                orderby: { "channelno": 'ASC' },
            };
            if (this.idepgchannel) {
                payload.idepgchannel = "[" + this.idepgchannel + "]"
            }

            try {
                const res = await this.mapEpgXmlData(payload);
                const parsedData = res.data ? xmlToJson.parse(res.data) : {};
                if (parsedData?.tv) {
                    // console.log(parsedData?.tv, 'parsedData_tv')
                    this.totalCount = parsedData?.tv?.totalcount || 0;
                    let channelsData = [];
                    if(!Array.isArray(parsedData?.tv?.channel) || parsedData?.tv?.totalcount == 1) {
                        channelsData = [parsedData?.tv?.channel];
                    }else {
                        channelsData = parsedData?.tv?.channel;
                    }
                    
                    const programsData = parsedData?.tv?.programme || [];
                    // const channelsData = [];
                    // const programsData = [];

                    this.channelsData = [...(this.channelsData || []), ...channelsData];
                    this.programsData = [...(this.programsData || []), ...programsData];
                    if(this.totalCount <= this.channelsData.length) {
                        this.showPaginationLoader = false;
                    } else {
                        this.showPaginationLoader = true;
                    }
                    // // Ensure the first channel is selected if available
                    // if (this.channelsData.length > 0) {
                    //     let selectedDate = (new Date()).toISOString().split('T')[0];
                    //     this.actSelectedChannel(this.channelsData[0], 0, selectedDate);
                    // }
                }
            } catch (err) {
                console.error("Error fetching EPG XML data:", err);
                this.finalData = [];
            }
        },
        doDate() {
            var days = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
            var months = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
            let now = new Date();
            let hours = '0';
            var today = days[now.getDay()] + now.getSeconds();
            this.upDateTime.date = String(now.getDate()).padStart(2, '0') + "-" + String(now.getMonth() + 1).padStart(2, '0') + "-" + now.getFullYear();
            let type = ['AM', 'PM'];
            let timeType;
            let min = '00';
            if (now.getHours() > 12) {
                hours = now.getHours() - 12;
                timeType = type[1]
            } else {
                hours = now.getHours();
                timeType = type[0]
            }
            if (now.getMinutes() < 10) {
                min = '0' + now.getMinutes();
            } else {
                min = now.getMinutes();
            }
            this.upDateTime.time = hours + ":" + min + " " + timeType;
        },
        actSelectedChannel(channelInfo) {
            // this.actionToPickActiveProgramsOFSelectedChannelANDSelectedDate(channelInfo.channel, channelInfo.i, this.selectedDate);
        },

        // actionToPickActiveProgramsOFSelectedChannelANDSelectedDate(channel, i, selectedDate) {
        //     this.setSelectedChannel(channel);
        //     this.activeProgramData = null; // Reset active program data
        //     this.selectedChannelIndex = i; // Set selected channel index
        //     this.activeChannelData = channel; // Store active channel data
        //     let selectedStartDate = moment.utc(moment(selectedDate + " 00:00:00")).local().valueOf();
        //     let selectedEndDate = moment.utc(moment(selectedDate + " 24:00:00")).local().valueOf();
        //     this.sortedProgramsData(channel).then((res) => {
        //         if (res?.length > 0) {
        //             const filteredPrograms = res.filter((item) => {
        //                 // Ensure the channel matches
        //                 const isChannelMatch = item.channel === channel.id;
        //                 // Ensure the date falls within the selected range
        //                 const programStart = moment.utc(moment(item.start, "YYYYMMDDHHmmss Z")).local().valueOf();
        //                 const programStop = moment.utc(moment(item.stop, "YYYYMMDDHHmmss Z")).local().valueOf();
        //                 const isDateMatch = programStart >= selectedStartDate && programStop <= selectedEndDate;
        //                 return isChannelMatch && isDateMatch;
        //             });
        //             // Deduplicate results based on unique program attributes
        //             this.activeProgramData = filteredPrograms.filter((item, index, self) => {
        //                 return index === self.findIndex((t) => (
        //                     t.channel === item.channel &&
        //                     t.start === item.start &&
        //                     t.stop === item.stop &&
        //                     t.title === item.title
        //                 ));
        //             });
        //         } else {
        //             this.activeProgramData = [];
        //         }
        //     }).catch((err) => {
        //         console.error("Error fetching program data:", err);
        //         this.activeProgramData = [];
        //     });

        //     const programs = this.$refs.programs;
        //     const timeline = this.$refs.timeline;
        //     if(this.isToday) {
        //         if(programs) programs.scrollLeft = this.isToday ? (this.liveLineLeft - (timeline.clientWidth / 2)) : 0;
        //     } else {
        //         if(programs) programs.scrollLeft = 0;
        //     };
        // },
        sortedProgramsData(channel) {
            let filterData = [];
            return new Promise((resolve, reject) => {
                try {
                    let singleData = this.programsData?.filter((item, i) => {
                        return item?.channel == channel?.id;
                    });
                    if (singleData) {
                        filterData = singleData?.sort((a, b) => (moment.utc(moment(a.start, "YYYYMMDDHHmmss Z")).local().valueOf()) - (moment.utc(moment(b.start, "YYYYMMDDHHmmss Z")).local().valueOf()));
                    }
                    resolve(filterData);
                } catch (error) {
                    resolve(filterData);
                }
            })
        },
        actSelectDate(date) {
            this.activeSelectedDate = date;
            this.setSelectedDate(date);
            this.checkIsToday();
            this.channelsData = null;
            this.programsData = null;
            this.pageNum = 1;
            // this.actionToPickActiveProgramsOFSelectedChannelANDSelectedDate(this.selectedChannel, this.selectedChannelIndex, date);
            this.fetchEpgXmlData(date, this.pageNum);
        },

        actSelectedProgram(condition) {
            let self = this;
            if (this.subscriberid) {
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                const contentPromise = this.getContent(condition.channel.contentid);
                this.activeChannel = condition.channel;
                let drmPromise = Promise.resolve(null);  // Default: no DRM promise
                window.selectedGenre = 'ALL CATEGORIES';
                // if (!isSafari) {
                    const urlencoded = new URLSearchParams();
                    urlencoded.append("contentid", condition.channel.contentid);
                    urlencoded.append("ios", isSafari ? true : false);
                    urlencoded.append("seclevel", "SW");
                    drmPromise = store.dispatch("actGetDRMToken", urlencoded);
                // }

                Promise.all([contentPromise, drmPromise])
                    .then(async ([item, drmRes]) => {
                        let episodeIndex = 0;
                        let episodeList = [item.data];
                        let totalEpisodeCount = 1;
                        let contentData = item.data;
                        if(item.reason) {
                            this.isLiveContentAccessError = true;
                            return;
                        }
                        if (drmRes?.reason) {
                            this.loading = false;
                            this.isLiveContentAccessError = true;
                            return;
                        }

                        if (drmRes?.data) {
                            contentData['drmTokenResp'] = drmRes.data;
                        }

                        let isPlaybackAllowed = await this.checkAvailabilityAllowsPlayback(contentData);
                        if (!isPlaybackAllowed) {
                            this.loading = false;
                            this.errorContentData = contentData;
                            this.isLiveContentAccessError = true;
                            return;
                        }
                        contentData.program = condition.program;


                        this.loading = false;
                        eventBus.$emit("live-player-active", contentData);
                    })
                    .catch((err) => {
                        console.log("err", err);
                        this.loading = false;
                    });
            } else {
                let localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
                localDisplayLang = localDisplayLang == 'eng' ? 'en' : localDisplayLang;
                this.redirectToLogin(localDisplayLang);
                this.loading = false;
            }
        },

        actUpDownArrow(type) {
            if (type === 'up') {
                // alert(type);
            } else {
                // alert(type);
            }
        },

        loadScript(src, async = true, type = "text/javascript") {
            return new Promise((resolve, reject) => {
                try {
                    const tag = document.createElement("script");
                    const container = document.head || document.body;

                    tag.type = type;
                    tag.async = async;
                    tag.src = src;

                    tag.addEventListener("load", () => {
                        resolve({ loaded: true, error: false });
                    });

                    tag.addEventListener("error", () => {
                reject({
                loaded: false,
                error: true,
                message: `Failed to load script with src ${src}`,
                });
            });

            container.appendChild(tag);
            } catch (error) {
            reject(error);
            }
        });
        },

        getImageSrc(value) {
            let src = value.replace(/&amp;/g, "&");
            console.log('src', src)
            return src ? `${src}` : this.placeholder_lands;
        },

        actPagination() {
            // let date = (new Date()).toISOString().split('T')[0];
            if(this.totalCount > this.channelsData?.length) {
                this.pageNum += 1;
                this.fetchEpgXmlData(this.activeSelectedDate, this.pageNum);
            } else {
                this.showPaginationLoader = false;
            }
        },
        actLoadError (e) {
            e.target.src = this.placeholder_lands;
        },
        onUserItemEnter() {
            observerInterSection();
        },
        onLeave() {
            // console.log('Element left the viewport!');
            // Handle logic when the element is no longer visible.
        },
        onUserItemLeave() {

        },
        onEnter() {
            this.actPagination();
        },
        generateTimeLabels() {
            const labels = [];
            const pxPerMinute = 5; // 5px per minute
            const interval = 30;   // every 15 minutes
            const totalMinutes = 24 * 60; // 1440 minutes

            for (let i = 0; i <= totalMinutes; i += interval) {
                const time = moment().startOf("day").add(i, "minutes").format("HH:mm");
                const left = i * pxPerMinute;

                labels.push({
                    label: time,
                    left: left,
                    width: 2, // Line width (you can change this)
                    height: '12px',
                    bottom: '0'
                });
            }

            this.timeLabels = labels;
        },
        leftScroll() {
            const programs = this.$refs.programs;
            const timeline = this.$refs.timeline;

            const SCROLL_STEP = timeline.clientWidth - 20;

            programs.scrollLeft -= SCROLL_STEP;
            timeline.scrollLeft = programs.scrollLeft;

            this.$nextTick(this.updateArrowVisibility);
        },
        rightScroll() {
            const programs = this.$refs.programs;
            const timeline = this.$refs.timeline;

            const SCROLL_STEP = timeline.clientWidth - 20;

            programs.scrollLeft += SCROLL_STEP;
            timeline.scrollLeft = programs.scrollLeft;

            this.$nextTick(this.updateArrowVisibility);
        },
        handleScroll(e) {
            // alert('handleScroll')
            const programs = this.$refs.programs;
            const channels = this.$refs.channels;
            const timeline = this.$refs.timeline;

            timeline.scrollLeft = programs.scrollLeft
        },
        updateLiveLine() {
            let now = new Date().getTime();
            const minutes = (now - this.epgStartTime) / (1000*60);
            this.liveLineLeft = minutes * this.pixelPerMinute;
        },
        checkIsToday() {
            if(this.selectedDate) {

                let now = new Date();
                let today =  now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, '0') + "-" + String(now.getDate()).padStart(2, '0');
                if(this.selectedDate === today) {
                    this.isToday = true;
                }else {
                    this.isToday = false;
                }
            }else {
                this.isToday = true;
            }
        },
        closePopup() {
            this.isLiveContentAccessError = false;
        },
        updateArrowVisibility() {
            const programs = this.$refs.programs;
            if (!programs) return;

            const { scrollLeft, clientWidth, scrollWidth } = programs;

            this.showLeftArrow = scrollLeft > 0;
            this.showRightArrow = scrollLeft + clientWidth < scrollWidth - 1;
        }
    },
    beforeDestroy() {
        const programs = this.$refs.programs;
        if (programs) {
            programs.removeEventListener('scroll', this.updateArrowVisibility);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";
@import "./Epg.scss";

.active {
    background: $primary-btn-color;
    color: #FFFFFF !important;
}

.user-img,
.cast-name {
    pointer-events: none;
}

.user-item:hover:not(.active) {
    background-color: black;
}

// .d-none {
//     display: none;
// }

.main-loader-layer {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0%;
    left: 0%;
    // transform: translate(-50%, -50%);
    background: rgba(49, 49, 49, 0.726);
    border: 0.1rem #262626 solid;
    width: 100vw;
    height: 100vh;
}

.inner-loader-layer {
    background: rgba(8, 8, 8, 0.726);
    border: 0.1rem #262626 solid;
    width: 10rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.epg-programme-100 {
    width: 100% !important;

}
.epg-container-block {
    background: #171923;
    .data-container {
        width: 100%;
        overflow-y: auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        .epg-data-container {
            display:flex;
            flex-direction: column;
            gap: 0.5rem;
            width: 100%;
            height: 100%;
            position: relative;
            .header-block {
                display: flex;
                height: 80px;
                position: sticky;
                top: 0;
                z-index: 10;
                .current-day-name {
                    width: 220px;
                    height: 100%;
                    text-align: center;
                    align-content: center;
                }
                .timelap-grid {
                    width: calc(100% - 220px);
                    height: 100%;
                    overflow: hidden;
                    position: relative;
                    .right-arrow {
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        background: gray;
                        border: 1px solid grey;
                        z-index: 9999;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 48%;
                        cursor: pointer;
                        img {
                            opacity: 0.5;
                            height: 65%;
                        }
                        &:hover {
                            img {
                                opacity: 1;
                            }
                        }
                    }
                    .left-arrow {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        background: gray;
                        border: 1px solid grey;
                        z-index: 9999;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 48%;
                        cursor: pointer;
                        img {
                            rotate: 180deg;
                            opacity: 0.5;
                            height: 65%;
                        }
                        &:hover {
                            img {
                                opacity: 1;
                            }
                        }
                    }
                    .left-arrow[style*="display: none"],
                    .right-arrow[style*="display: none"] {
                    pointer-events: none;
                    }
                    .timelap-container {
                        width: calc(100%);
                        height: 100%;
                        overflow: hidden;
                        position: relative;
                        .timelapse-track {
                            display: flex;
                            justify-content: space-between;
                            // background: #333;
                            color: #fff;
                            width: 100%;
                            height: 100%;
                            position: relative;
                            z-index: 999;
                            .time-line {
                                // display: flex;
                                // flex-direction: row-reverse;
                                // justify-content: flex-end;
                                // position: absolute;
                                // gap: 0.5rem;
                                width: 150px;
                                // border: 1px solid gray;
                                // padding: 0.5rem 0.75rem;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                display: inline-block;
                                color: #f1f1f1;
                                background: #828282;
                                border-right: 2px solid #121212;
                                line-height: 38px;
                                padding: 0 30px;
                                // .time {
                                //     margin-left: -20px;
                                // }
                                // .line {
                                    
                                // }
                            }
                            .time-line_0 {
                                .time {
                                    margin-left: 10px !important;
                                }
                                // .line {
                                    
                                // }
                            }
                            .time-line_48 {
                                .time {
                                    display: none;
                                }
                                // .line {
                                    
                                // }
                            }
                        }
                    }
                }
            }
            .epg-body {
                height: calc(100% - 80px);
                overflow-y: scroll;
                scroll-snap-type: y mandatory;
                margin-top: 0.2rem;
                // padding: 0 2rem;
                scrollbar-gutter: stable;
                scrollbar-width: auto;
                scrollbar-color: red transparent;
                .channel-program-block {
                    display: flex;
                    flex-direction: row;
                    height: 100%;
                    .channel-block {
                        width: 220px;
                        height: 100%;
                        .channel-block-overlay {
                            position: relative;
                            width: 100%;
                            // .current-day-name {
                            //     width: 100%;
                            //     height: 80px;
                            //     display:flex;
                            //     justify-content: center;
                            //     align-items: center;
                            //     // position: fixed;
                            //     z-index: 999;
                            // }
                            .channel-block-single {
                                width: 100%;
                                height: 80px;
                                .channel-box {
                                    display:flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 220px;
                                    height: 100%;
                                }
                                .loader {
                                    margin: auto;
                                    width: 98%;
                                    height: 98%;
                                    border-radius: 0.5rem;
                                    background: linear-gradient(to right, #1a202c, #1a202c);
                                }
                            }
                        }
                    }
                    .program-block {
                        width: calc(100% - 220px);
                        height: 100%;
                        // overflow-x: auto;
                        .program-block-overlay {
                            overflow-x: auto;
                            // overflow-y: hidden;
                            position: relative;
                            // .timelapse-track {
                            //     display: flex;
                            //     justify-content: space-between;
                            //     // background: #333;
                            //     color: #fff;
                            //     width: 100%;
                            //     height: 80px;
                            //     position: relative;
                            //     z-index: 999;
                            //     .time-line {
                            //         display: flex;
                            //         flex-direction: column;
                            //         justify-content: center;
                            //         align-items: center;
                            //         position: absolute;
                            //     }
                            // }
                            .program-block-single {
                                width: 100%;
                                height: 80px;
                                .program-box {
                                    // width: 7200px;
                                    height: 100%;
                                }
                                .loading-box {
                                    width: 7188px;
                                    padding: 0.1rem;
                                    margin: auto;
                                    height: 98%;
                                    border-radius: 0.5rem;
                                    background: linear-gradient(to right, #1a202c, #1a202c);
                                }
                            }
                            &::-webkit-scrollbar {
                                height: 4px; /* Set scrollbar height */
                                position: absolute;
                                bottom: 0; /* Position scrollbar at the bottom */
                                width: 50%; /* Full width for the horizontal scrollbar */
                                transform: translateY(-50%); /* Vertically center the scrollbar */
                            }

                            &::-webkit-scrollbar-track {
                                width: 50%;
                                border-radius: .1rem
                            }

                            &::-webkit-scrollbar-thumb {
                                width: 50%;
                                background: #0a8922 !important;
                                border-radius: .6rem
                            }

                            &::-webkit-scrollbar-thumb:hover {
                                background: #0a8922 !important;
                            }
                        }
                    }
                }
                .channel-program-block-loading {
                    display: flex;
                    flex-direction: row;
                    height: 100%;
                    .channel-block {
                        width: 220px;
                        height: 100%;
                        .channel-block-overlay {
                            position: relative;
                            width: 100%;
                            .channel-block-single {
                                width: 100%;
                                height: 80px;
                                .channel-box {
                                    display:flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 100%;
                                    height: 100%;
                                }
                                .loader {
                                    width: 98%;
                                    height: 98%;
                                    border-radius: 0.5rem;
                                    background: linear-gradient(to right, #1a202c, #1a202c);
                                }
                            }
                        }
                    }
                    .program-block {
                        width: calc(100% - 220px);
                        height: 100%;
                        // overflow-x: auto;
                        .program-block-overlay {
                            overflow-x: auto;
                            // overflow-y: hidden;
                            position: relative;
                            .program-block-single {
                                width: 100%;
                                height: 80px;
                                .program-box {
                                    // width: 7200px;
                                    height: 100%;
                                }
                                .loading-box {
                                    width: 7188px;
                                    padding: 0.1rem;
                                    margin: auto;
                                    height: 98%;
                                    background: linear-gradient(to right, #1a202c, #1a202c);
                                }
                            }
                            &::-webkit-scrollbar {
                                height: 4px; /* Set scrollbar height */
                                position: absolute;
                                bottom: 0; /* Position scrollbar at the bottom */
                                width: 50%; /* Full width for the horizontal scrollbar */
                                transform: translateY(-50%); /* Vertically center the scrollbar */
                            }

                            &::-webkit-scrollbar-track {
                                width: 50%;
                                border-radius: .1rem
                            }

                            &::-webkit-scrollbar-thumb {
                                width: 50%;
                                background: #0a8922 !important;
                                border-radius: .6rem
                            }

                            &::-webkit-scrollbar-thumb:hover {
                                background: #0a8922 !important;
                            }
                        }
                    }
                }
                .load-wrapper {
                    width: 100% !important;
                    height: 100vh !important;
                }
            }
            .pagination-intersector {
                display:flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 80px;
                background: linear-gradient(to right, #1a202c, #1a202c);
            }
        }

    }
}

@media only screen and (max-width: 768px) {
    .epg-container-block {
        .data-container {
            .epg-data-container {
                .header-block {
                    .current-day-name {
                        width: 100px;
                    }
                    .timelap-grid {
                        width: calc(100% - 100px);
                    }
                }
                .epg-body {
                    .channel-program-block {
                        .channel-block {
                            width: 100px !important;
                        }
                        .program-block {
                            width: calc(100% - 100px) !important;
                        }
                    }
                }
            }
        }
    }
}


.confirmation-box {
  .confirmation-body {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    text-align: center;
    .login-button {
      width: 50%;
    }
  }
}
</style>